import { baseApi, apiTags } from "../baseApi";
import type { File, Category } from "../types/api.types";
import type { LaravelQueryBuilder } from '../types/laravelRequest';

export const filesApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getFiles: builder.query<File[], void>({
            query: () => ({
                resource: "crm-files",
                action: "index",
                method: "GET",
                queryBuilder: (query: LaravelQueryBuilder) => {
                    return query.with("categories");
                },
            }),
            providesTags: (result) =>
                result && Array.isArray(result)
                    ? [
                          { type: apiTags.File, id: "LIST" },
                          ...result.map((item) => ({ type: apiTags.File, id: item.id })),
                      ]
                    : [{ type: apiTags.File, id: "LIST" }],
        }),
        getCategories: builder.query<Category[], void>({
            query: () => ({
                resource: "crm-category",
                action: "index",
                method: "GET",
                queryBuilder: (query: LaravelQueryBuilder) => {
                    return query.whereNull("parent_id").orderBy("order").with("children.children");
                },
            }),
            providesTags: (result) =>
                result && Array.isArray(result)
                    ? [
                          { type: apiTags.Category, id: "LIST" },
                          ...result.map((item) => ({ type: apiTags.Category, id: item.id })),
                      ]
                    : [{ type: apiTags.Category, id: "LIST" }],
        }),
        toggleFileDelete: builder.mutation<File, number>({
            query: (fileId) => ({
                resource: "crm-files",
                action: "toggle-delete",
                method: "POST",
                data: { file_id: fileId },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: apiTags.File, id: arg },
                { type: apiTags.File, id: "LIST" },
            ],
        }),
    }),
});

export const { useGetFilesQuery, useGetCategoriesQuery, useToggleFileDeleteMutation } = filesApi;
